import { DialogActions, DialogTitle, makeStyles } from '@material-ui/core';
import { Alert, AppBar, Autocomplete, Button, Chip, Dialog, DialogContent, DialogContentText, FormControl, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { AntTab, AntTabs } from '../../../components/ant-tab';
import Spacer from '../../../components/Spacer';
import TimeSheetMissionService from '../../../services/TimeSheetMissionService';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import CardTravelIcon from '@mui/icons-material/CardTravel';
import VehicleService from '../../../services/VehicleService';

const useStyles = makeStyles((theme) => ({
   tab: {
          width: "50%",
        },
        AppBar: {
          borderRadius: "8px",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
        },
}));

const DetailsMissionDialog = (props) => {
    const { open, onClose, missionData } = props;
    const classes = useStyles();
    const missionId = missionData ? missionData.mission_planning_id : null;
    const agendaId = missionData ? missionData.mission_planning_agenda_id : null;
    const timesheetId = missionData ? (missionData.mission_timesheet_id || missionData.mission_kilometer_id) : null;
    const timesheetState = missionData ? (missionData.mission_timesheet_state || missionData.kilometrage_state) : null;
    const [value, setValue] = useState(0);
    const [drivers, setDrivers] = useState([]);
    const [destinations, setDestinations] = useState([])
    const [timesheetLoading, setTimesheetLoading] = useState(false);
    const [timesheetError, setTimesheetError] = useState('');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [agendas, setAgendas] = useState([])

      const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

     useEffect(() => {
        let isCurrentSelection = true;

        async function getTimesheetData() {
          setTimesheetLoading(true);
          setTimesheetError('');
          setDestinations([]);
          setAgendas([]);

          if (!missionId || !agendaId || !timesheetId) {
            setTimesheetError('Timesheet non disponible pour cette mission.');
            setTimesheetLoading(false);
            return;
          }

          try {
            const result = await TimeSheetMissionService.retrieveDestinationsWithTransportTimesheet(
              missionId,
              agendaId,
              timesheetId
            );
            if (!isCurrentSelection) {
              return;
            }
            const details = result?.status && Array.isArray(result.data) ? result.data : [];
            if (!details.length) {
              setTimesheetError(result?.message || 'Timesheet non disponible pour cette mission.');
              return;
            }

            setAgendas([{
              mission_planning_agenda_id: agendaId,
              reference: missionData.reference,
            }]);
            setDestinations([{ agenda_id: agendaId, details }]);
          } catch (error) {
            if (!isCurrentSelection) {
              return;
            }
            console.error('Erreur lors de la récupération de la timesheet :', error);
            setTimesheetError('Une erreur est survenue lors de la récupération de la timesheet.');
          } finally {
            if (isCurrentSelection) {
              setTimesheetLoading(false);
            }
          }
        }
      
        const getDrivers = async () => {
            try {
                   const driversRes = await VehicleService.getDriversMission();
                if (isCurrentSelection) {
                  setDrivers(driversRes?.data || []);
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des conducteurs ou véhicules:', error);
            }
        };

        setValue(0);
        if (missionId) {
          getTimesheetData();
            getDrivers();
        }

        return () => {
          isCurrentSelection = false;
        };
      }, [missionId, agendaId, timesheetId, missionData.reference]);

  return (
    <Dialog 
        open={open} 
        onClose={onClose}
        aria-labelledby="mission-dialog-title"
        aria-describedby="mission-dialog-description"
        maxWidth="lg"
        fullWidth>
        <DialogTitle  id="form-dialog-title" style={{ color: "white" }}>
            Mission {missionData.reference}
        </DialogTitle>
        <DialogContent dividers>
            <Spacer y={2}/>
                 <AppBar position="static" color="default" className={classes.AppBar}>
                                    <AntTabs
                                      value={value}
                                      onChange={handleChange}
                                      variant="scrollable"
                                      scrollButtons="auto"
                                      aria-label="scrollable auto tabs example"
                                    >
                                      <AntTab label="Détails de la mission" className={classes.tab} />
                                      <AntTab label="Timesheet" className={classes.tab} />
                                      <AntTab label="Détails des voitures" className={classes.tab} />
                                      <AntTab label="Demande de sollicitation" className={classes.tab} />

                                    </AntTabs>
                                  </AppBar>
            <Spacer y={2}/>

            {value === 0 && (
                <DialogContentText>
                    <FormControl fullWidth>
                    <label><b>Réference : </b> {missionData.reference}</label>
                    </FormControl>
                    <FormControl fullWidth>
                    <label><b>Objet : </b> {missionData.mission_title}</label>
                    </FormControl>
                    <FormControl fullWidth>
                    <lable><b>Dates : </b> {formatDate(missionData.date_begin)} au {formatDate(missionData.date_end)}</lable>
                    </FormControl>
                    <FormControl fullWidth>
                    <label><b>Destination : </b> {missionData.lieu}</label>
                    </FormControl>
                    <FormControl fullWidth>
                    <label><b>Missionnaires : </b></label>
                    <ul>
                        {missionData.users && missionData.users.map((missionnaire, index) => (
                            <li key={index}>{missionnaire.nom}</li>
                        ))}
                    </ul>
                    </FormControl>

                    </DialogContentText>
            )}  
            {
                value === 1 && 
                  <DialogContentText>
                     {
                timesheetLoading ?
                <Alert severity="info" style={{ margin: "10px", marginBottom: "10px" }}>
                 Chargement de la <b>timesheet</b>...
                </Alert>
                : (timesheetError || destinations.length === 0) ?
                <Alert severity="warning" style={{ margin: "10px", marginBottom: "10px" }}>
                 {timesheetError || 'Timesheet non disponible pour cette mission.'}
                </Alert>
                : <>
                { agendas?.map((agenda, agendIndex) => {
          return <React.Fragment key={agenda.mission_planning_agenda_id}>
              <fieldset
                        style={{
                          borderRadius: "10px",
                          color: "#1976d2",
                          fontSize: "24px",
                          marginTop: "4px",
                        }}
                      >
                        <legend>
                          &nbsp;&nbsp;
                          {`Timesheet : ${agenda.reference}`}
                          &nbsp; &nbsp;
                        </legend>
            
            <Grid item xs={12} variant="outlined">
              {timesheetState === "CONFIRMED" ? (
                           <Chip
                             label="Timesheet validée"
                             color="success"
                             variant="contained"
                             style={{ marginBottom: "10px" }}
                           />
                         ) : (timesheetState === "REFUSED" ? (
                           <Chip
                             label="Timesheet refusée"
                             color="error"
                             variant="contained"
                             style={{ marginBottom: "10px" }}
                           />
                         ) : (
                          timesheetState === "PENDING" ? (
                           <Chip
                             label="Timesheet en attente"
                             color="warning"
                             variant="contained"
                             style={{ marginBottom: "10px" }}
                           />
                          ) : null
                         ))}
              <TableContainer sx={{ boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;", marginTop: 2, borderRadius: "8px" }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead sx={{ backgroundColor: "rgba(0, 0, 0, 0.8)" }}>
                    <TableRow>
                      <TableCell sx={{ minWidth: '150px' }}>Date</TableCell>
                      <TableCell sx={{ minWidth: '120px' }}>Heure départ</TableCell>
                      <TableCell sx={{ minWidth: '120px' }}>Heure arrivée</TableCell>
                      <TableCell sx={{ minWidth: '180px' }}>Lieu de départ</TableCell>
                      <TableCell sx={{ minWidth: '180px' }}>Lieu d'arrivée</TableCell>
                      <TableCell sx={{ minWidth: '250px' }}>Missionnaires</TableCell>
                      <TableCell sx={{ minWidth: '120px' }}>Type</TableCell>
                      <TableCell sx={{ minWidth: '130px' }}>Kilométrage</TableCell>
                      <TableCell sx={{ minWidth: '180px' }}>Transport(s)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {destinations[agendIndex]?.details.map((destination, index) => (
                      <TableRow key={destination.mission_timesheet_destination_id || index}>
                        <TableCell sx={{ minWidth: '150px' }}>
                          <label className={classes.labelPosition} style={{ color: "grey", fontSize: "16px" }}>
                            {formatDate(destination.date_begin)} - {formatDate(destination.date_end)}
                          </label>
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px' }}>
                          <label className={classes.labelPosition} style={{ color: "grey", fontSize: "16px" }}>
                            {destination.heure_begin || '-'}
                          </label>
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px' }}>
                          <label className={classes.labelPosition} style={{ color: "grey", fontSize: "16px" }}>
                            {destination.heure_end || '-'}
                          </label>
                        </TableCell>
                        <TableCell sx={{ minWidth: '180px' }}>
                          <label className={classes.labelPosition} style={{ color: "grey", fontSize: "16px" }}>
                            {destination.lieu_depart || destination.depart || destination.direction_location || '-'}
                          </label>
                        </TableCell>
                        <TableCell sx={{ minWidth: '180px' }}>
                          <label className={classes.labelPosition} style={{ color: "grey", fontSize: "16px" }}>
                            {destination.lieu_arrivee || destination.arriver || destination.direction_location || '-'}
                          </label>
                        </TableCell>
                        <TableCell sx={{ minWidth: '180px' }}>
                          <FormControl fullWidth variant="outlined" size="small">
                            <Autocomplete id="tags-outlined"
                              options={destination?.missionnaries || []}
                              getOptionLabel={(option) => (option ? option.name.toString() : '')}
                              filterSelectedOptions
                              value={destination?.missionnaries}
                              multiple
                              readOnly
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  id="outlined-basic"
                                  size="small"
                                  variant="outlined"
                                />
                              )}
                            />
                          </FormControl>
                        </TableCell>
                        <TableCell sx={{ minWidth: '120px' }}>
                          {destination.type === "DM" ? <Chip icon={<CardTravelIcon />} label="Mission" variant="outlined" color="info" /> : <Chip icon={<TimeToLeaveIcon />} label="Délai de route" variant="outlined" color="info" />}
                        </TableCell>
                        <TableCell>
                          <FormControl fullWidth variant="outlined" size="small">
                            {destination.distance_km ?? destination.mission_timesheet_details_km ?? 0} km
                          </FormControl>
                        </TableCell>
                        <TableCell>
                          {destination?.transports
                            ?.map((transport) => transport.vhc_imm || transport.transport_type_designation || transport.transport_type)
                            .filter(Boolean)
                            .join(', ') || destination.transport_type_designation || destination.transport_type || '-'}
                        </TableCell>
                      </TableRow>
                    ))}

                  </TableBody>
                </Table>
              </TableContainer>
             
            </Grid>
            </fieldset>
            </React.Fragment>
          })}
                </>
            }
                    </DialogContentText>
            }

            {
                value === 2 && 
                <DialogContentText>
                  {
                    missionData?.vehicles?.length === 0 ?
                    <Alert severity="warning" style={{ margin: "10px", marginBottom: "10px" }}>
                      Aucune <b>voiture</b> n'est assignée à cette mission.
                    </Alert>
                    : 
                    <TableContainer sx={{ boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;", marginTop: 2, borderRadius: "8px" }}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead sx={{ backgroundColor: "rgba(0, 0, 0, 0.8)" }}>
                                <TableRow>
                                    <TableCell>Immatriculation</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Chauffeur</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {missionData?.vehicles?.map((vehicle) => (
                                    <TableRow >
                                        <TableCell>{vehicle.vhc_imm}</TableCell>
                                        <TableCell>{vehicle.vhc_type}</TableCell>
                                        <TableCell>{vehicle.driver_id ? drivers.find(driver => driver.user_id === vehicle.driver_id)?.name : 'Aucun chauffeur assigné'
                                        }</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                  }
                </DialogContentText>
            }
            {
              value === 3 &&
              <DialogContentText>
                <Alert severity="info" style={{ margin: "10px", marginBottom: "10px" }}>
                  Aucune sollicitation des voitures  pour cette mission.
                </Alert>
                </DialogContentText>
            }
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="info"  
                 onClick={onClose}>
                    Fermer
                </Button>
                <Spacer x={1} />
            </DialogActions>
    </Dialog>
  );
}

export default DetailsMissionDialog;
